import React from 'react';
import RepVisitsUnlockPremiumView from '../RepVisitsUnlockPremiumView';
import recommendationsUnlockMessages from './recommendations-unlock-messages';
import PageTitle from '../../components/PageTitle';

const unlockPremiumProps = {
  activeStyle: 'recommendations',
  messages: recommendationsUnlockMessages,
};

const RepVisitsRecommendationsUnlockPage = () => (
  <div>
    <PageTitle title="RepVisits" category="Intersect" />
    <RepVisitsUnlockPremiumView {...unlockPremiumProps} />
  </div>
);

export default RepVisitsRecommendationsUnlockPage;
